import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Control, FieldValues, Path } from "react-hook-form";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

interface MonthSelectFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
}

export function MonthSelectField<T extends FieldValues>({
  control,
  name,
  label = "Month",
}: MonthSelectFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-0">
          <FormLabel>{label}</FormLabel>
          <Select
            // field.value is a NUMBER (1-12); Select needs a string
            value={
              field.value != null
                ? String(field.value)
                : undefined
            }
            onValueChange={(val) => field.onChange(Number(val))}
          >
            <FormControl>
              <SelectTrigger className="">
                <SelectValue placeholder="Select a month" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {MONTHS.map((month, index) => (
                <SelectItem
                  key={index + 1}
                  value={String(index + 1)}
                >
                  {month}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
